var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaravelle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "160.000000pt",
    height: "85.000000pt",
    viewBox: "0 0 160.000000 85.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,85.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156 648 c-9 -13 -16 -43 -16 -69 0 -47 14 -68 53 -82 21 -8 64 10 72 31 9 25 -4 27 -25 4 -26 -28 -45 -28 -64 0 -18 26 -21 71 -6 99 14 25 56 25 72 -1 15 -23 28 -26 28 -7 0 45 -87 64 -114 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 589 c-17 -45 -29 -84 -27 -86 8 -8 26 8 26 23 0 10 12 14 39 14 31 0 41 -4 46 -20 3 -11 12 -20 20 -20 16 0 -43 161 -62 167 -6 2 -24 -32 -42 -78z m69 -25 c0 -2 -11 -4 -25 -4 -28 0 -32 18 -14 52 11 20 12 20 25 -12 8 -18 14 -34 14 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 585 c0 -50 4 -85 10 -85 6 0 10 14 10 30 0 39 27 51 49 23 9 -11 21 -29 27 -39 19 -31 27 -8 9 25 -14 29 -14 33 0 47 38 39 6 84 -61 84 l-44 0 0 -85z m89 51 c19 -23 2 -46 -35 -46 -31 0 -34 3 -34 30 0 26 3 30 29 30 16 0 34 -6 40 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 648 c-59 -161 -56 -148 -42 -148 5 0 13 9 16 20 5 15 15 20 45 20 30 0 40 -5 45 -20 7 -22 25 -28 24 -7 -1 24 -56 151 -68 155 -6 2 -15 -7 -20 -20z m36 -53 c11 -34 11 -35 -17 -35 -28 0 -28 1 -17 35 6 19 13 35 17 35 4 0 11 -16 17 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774 585 c17 -47 36 -85 43 -85 6 0 19 21 29 48 9 26 23 62 31 81 16 41 16 41 0 41 -8 0 -22 -26 -32 -60 -10 -34 -22 -63 -26 -66 -4 -2 -17 25 -29 61 -12 36 -27 65 -35 65 -9 0 -3 -25 19 -85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910 585 l0 -85 61 0 c37 0 58 4 54 10 -3 6 -24 10 -46 10 -37 0 -39 2 -39 30 0 28 3 30 35 30 19 0 35 5 35 10 0 6 -16 10 -35 10 -31 0 -35 3 -35 25 0 23 4 25 40 25 22 0 40 5 40 10 0 6 -25 10 -55 10 l-55 0 0 -85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050 585 l0 -85 55 0 c30 0 55 5 55 10 0 6 -18 10 -40 10 l-40 0 0 75 c0 60 -3 75 -15 75 -12 0 -15 -16 -15 -85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180 585 l0 -85 55 0 c30 0 55 5 55 10 0 6 -18 10 -40 10 l-40 0 0 75 c0 60 -3 75 -15 75 -12 0 -15 -16 -15 -85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320 585 l0 -85 56 0 c34 0 53 4 49 10 -3 6 -24 10 -46 10 -37 0 -39 2 -39 30 0 28 3 30 35 30 19 0 35 5 35 10 0 6 -16 10 -35 10 -31 0 -35 3 -35 25 0 22 4 25 39 25 22 0 43 5 46 10 4 6 -15 10 -49 10 l-56 0 0 -85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418 413 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 288 c0 -25 3 -30 10 -18 9 13 12 13 24 -3 12 -16 14 -15 12 15 -1 26 -6 34 -24 36 -19 3 -22 -1 -22 -30z m40 12 c0 -5 -7 -10 -15 -10 -8 0 -15 5 -15 10 0 6 7 10 15 10 8 0 15 -4 15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 291 c0 -17 4 -32 8 -35 4 -2 6 11 4 30 -5 42 -12 45 -12 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790 291 c0 -17 4 -32 8 -35 4 -2 6 11 4 30 -5 42 -12 45 -12 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849 300 c-1 -11 -2 -26 -3 -32 -1 -7 9 -14 22 -14 12 -1 22 5 22 12 0 8 -4 14 -9 14 -5 0 -12 7 -15 16 -3 8 -2 12 4 9 6 -3 10 -1 10 4 0 20 -30 11 -31 -9z m21 -30 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932 288 c-2 -34 1 -38 21 -37 15 1 17 3 5 6 -10 2 -18 17 -21 36 -4 31 -4 31 -5 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 299 c-4 -8 -3 -9 4 -5 8 5 12 0 12 -13 0 -12 -5 -21 -11 -21 -5 0 -7 5 -4 10 3 6 1 10 -5 10 -18 0 -6 -25 13 -28 12 -3 17 4 17 22 0 28 -15 42 -26 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 281 c1 -14 9 -26 17 -28 10 -3 11 -2 4 4 -7 4 -14 17 -17 28 -5 16 -5 15 -4 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 275 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 275 c1 -11 9 -21 19 -23 13 -3 17 3 16 25 -1 23 -2 24 -6 6 -5 -27 -20 -30 -26 -5 -3 13 -4 12 -3 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650 280 c0 -11 2 -20 4 -20 2 0 6 9 9 20 3 11 1 20 -4 20 -5 0 -9 -9 -9 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767 279 c4 -13 8 -18 11 -10 2 7 -1 18 -6 23 -8 8 -9 4 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974 289 c-8 -14 21 -43 35 -35 13 9 14 33 2 40 -5 4 -7 -4 -4 -15 4 -16 2 -20 -8 -17 -8 3 -13 13 -13 22 2 19 -2 21 -12 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034 275 c1 -11 9 -21 19 -23 13 -3 17 3 16 25 -1 23 -2 24 -6 6 -5 -27 -20 -30 -26 -5 -3 13 -4 12 -3 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080 280 c0 -11 2 -20 4 -20 2 0 6 9 9 20 3 11 1 20 -4 20 -5 0 -9 -9 -9 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112 280 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133 284 c-4 -10 0 -22 10 -29 9 -7 13 -16 9 -21 -4 -4 1 -2 11 5 17 14 24 61 8 61 -5 0 -8 -6 -7 -12 0 -7 -3 -13 -9 -13 -5 0 -9 6 -9 13 2 17 -5 15 -13 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193 281 c1 -14 9 -26 17 -28 10 -3 11 -2 4 4 -7 4 -14 17 -17 28 -5 16 -5 15 -4 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495 270 c6 -10 4 -12 -11 -6 -15 6 -17 5 -6 -5 9 -9 15 -10 23 -2 8 8 7 13 -2 18 -8 6 -10 4 -4 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 271 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaravelle);
export default __webpack_public_path__ + "static/media/caravelle.40fec33a31079911e100ae045267b890.svg";
export { ForwardRef as ReactComponent };